export const formatEuro = (value?: number | string | null): string => {
  if (value === null || value === undefined || value === '') return '';

  const num =
    typeof value === 'string' ? parseFloat(value.replace(',', '.')) : value;
  if (isNaN(num)) return '';

  const parts = num.toString().split('.');
  let minimumFractionDigits = 0;
  const maximumFractionDigits = 2;

  if (parts[1]?.length === 1) {
    minimumFractionDigits = 2;
  } else if (!parts[1]) {
    minimumFractionDigits = 0;
  }

  return ` ${num.toLocaleString('fr-FR', {
    minimumFractionDigits,
    maximumFractionDigits,
  })} €`;
};
